<template>
  <b-modal
    v-if="isI18n"
    id="operation-deactivate-modal-confirm"
    v-model="active"
    data-cy="operation-modal-confirm"
    :destroy-on-hide="true"
    aria-role="dialog"
    aria-label="Activar/Desactivar Operación"
    has-modal-card
    trap-focus
    :on-cancel="close"
    aria-modal
    width="400">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-body">
        <div class="modal-card-title modal-title">
          {{ $t('title') }}
        </div>
        <a
          class="close-modal delete"
          type="button"
          @click="close()" />
      </header>
      <section class="modal-card-body">
        <p>
          {{ operation.isActive ? $t('subtitleDeactivate') : $t('subtitleActivate') }}
        </p>
        <p>
          <strong> {{ $t('operation') }} </strong> {{ operation.companyOperationId }}<br>
          <strong> {{ $t('type') }} </strong>{{ getOperationTypeTitle() }} <br>
          <strong> {{ $t('clientIdNumber') }} </strong> {{ operation.client ? operation.client['idNumber'] : '' }}<br>
        </p>
        <p class="text-align-center">
          {{ $t('confirm') }}
        </p>
        <div class="text-align-center reasons-form">
          <b-field custom-class="has-text-weight-small">
            <b-select id="reason" v-model="reason" size="is-small" rounded name="reason">
              <option value="">{{ $t('pickReason') }}</option>
              <option v-for="key in operation.isActive ? $t('reasonsForDisable') : $t('reasonsForEnable')" :key="key" :value="key">
                {{ key }}
              </option>
            </b-select>
          </b-field>
          <b-field>
            <b-checkbox v-if="stateUser && operation.isActive || !stateUser && !operation.isActive" id="deactivateUser" v-model="disable" class="checkbox">
              {{ operation.isActive ? $t('deactivateUser') : $t('activateUser') }}
            </b-checkbox>
          </b-field>
        </div>
        <div class="buttons is-pulled-right">
          <b-button
            id="operation-modal-button-no"
            data-cy="operation-modal-button-no"
            class="button is-button-secondary"
            label="No"
            rounded
            @click="close()" />
          <b-button
            id="operation-modal-button-continuar"
            data-cy="operation-modal-button-continuar"
            label="Continuar"
            rounded
            :disabled="!reason"
            class="button is-button-primary"
            @click="confirm()" />
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    operation: {
      type: Object,
      required: true
    },
    stateUser: {
      type: Boolean,
      required: false
    },
    isComponentModalActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      reason: '',
      disable: true
    };
  },
  computed: {
    active() {
      return this.$props.isComponentModalActive;
    },
    isI18n() { return ['br', 'cl', 'pe'].includes(this.$i18n.locale); }
  },
  methods: {
    getOperationTypeTitle() {
      return {
        MORTGAGE: `🏡 ${this.$t('mortgage')}`,
        COMPLEMENTARY: `💰 ${this.$t('complementary')}`,
        HOME_EQUITY: `🏡 ${this.$t('homeEquity')}`,
        PARKING: `🅿️ ${this.$t('parking')}`,
        SME: `🚀 ${this.$t('sme')}`
      }[this.operation.type];
    },
    confirm() {
      this.$emit('process',
        this.operation,
        this.disable,
        !this.operation.isActive,
        this.reason);
      this.reason = '';
    },
    close() {
      this.$emit('cancelProcess');
    }
  }
};
</script>

<style scoped>
.modal-card-body p {
  padding-bottom: 1rem;
}
.reasons-form {
  font-size: .8rem;
}
.modal-card-body {
  position: relative;
}
.modal-card-body .close-modal {
  position: absolute;
  right: 20px;
  top:20px;
  width: 40px;
}
.modal-title {
  color: #00CCD1;
  font-weight:500;
}
</style>
<i18n>
{
  "cl": {
    "title": "Atención",
    "subtitleDeactivate": "Se procederá a desactivar la operación con los siguientes datos:",
    "subtitleActivate": "Se procederá a activar la operación con los siguientes datos:",
    "confirm": "¿Estás seguro que deseas continuar?",
    "operation": "Operación:",
    "type": "Tipo:",
    "graceMonths": "Meses de gracia:",
    "active": "Activa",
    "inactive": "Inactiva",
    "mortgage": "Hipotecario",
    "complementary": "Complementario",
    "parking": "Estacionamiento",
    "sme": "SME",
    "homeEquity": "Hipotecario",
    "deactivateUser": "Desactivar Usuario",
    "activateUser": "Activar Usuario",
    "clientIdNumber": "RUT:",
    "pickReason": "Elije un Motivo",
    "reasonsForDisable": [
      "Sin Efecto",
      "Prepago Total",
      "Prepago Total (Seguro de Desgravamen)",
      "Cobranza Judicial (Siniestro)",
      "Corrección de problemas",
      "Otro"
    ],
    "reasonsForEnable": [
      "Sin Efecto",
      "Error humano al Desactivar Operación",
      "Pagos pendientes de aplicar",
      "Pagos mal realizados",
      "Otro"
    ]
  },
  "pe": {
    "title": "Atención",
    "subtitleDeactivate": "Se procederá a desactivar la operación con los siguientes datos:",
    "subtitleActivate": "Se procederá a activar la operación con los siguientes datos:",
    "confirm": "¿Estás seguro que deseas continuar?",
    "operation": "Operación:",
    "type": "Tipo:",
    "graceMonths": "Meses de gracia:",
    "active": "Activa",
    "inactive": "Inactiva",
    "mortgage": "Hipotecario",
    "complementary": "Complementario",
    "parking": "Estacionamiento",
    "sme": "SME",
    "homeEquity": "Hipotecario",
    "deactivateUser": "Desactivar Usuario",
    "activateUser": "Activar Usuario",
    "clientIdNumber": "RUT:",
    "pickReason": "Elije un Motivo",
    "reasonsForDisable": [
      "Sin Efecto",
      "Prepago Total",
      "Prepago Total (Seguro de Desgravamen)",
      "Cobranza Judicial (Siniestro)",
      "Corrección de problemas",
      "Otro"
    ],
    "reasonsForEnable": [
      "Sin Efecto",
      "Error humano al Desactivar Operación",
      "Pagos pendientes de aplicar",
      "Pagos mal realizados",
      "Otro"
    ]
  },
  "br": {
    "title": "Atenção",
    "subtitleDeactivate": "A operação será desativada com os seguintes dados:",
    "subtitleActivate": "A operação será ativada com os seguintes dados:",
    "confirm": "Você tem certeza que quer continuar?",
    "operation": "Operação",
    "type": "Tipo:",
    "graceMonths": "Meses de graça:",
    "active": "Ativo",
    "inactive": "Inativo",
    "mortgage": "Hipoteca",
    "complementary": "Complementar",
    "parking": "Estacionamento",
    "sme": "SME",
    "homeEquity": "Hipoteca",
    "deactivateUser": "Desativar Usuário",
    "activateUser": "Ativar Usuário",
    "clientIdNumber": "RUT:",
    "pickReason": "Escolha um Motivo",
    "reasonsForDisable": [
      "Efeito do pecado",
      "Pré-pago Total",
      "Pré-pago Total (Seguro de Desgravação)",
      "Cobranza Judicial (Siniestro))",
      "Correção de problemas",
      "Outro"
    ],
    "reasonsForEnable": [
      "Efeito do pecado",
      "Erro humano ao desativar a operação",
      "Pagamentos pendentes de aplicar",
      "Pagamentos mal realizados",
      "Outro"
    ]
  }
}
</i18n>
